<template>
  <div>

    
    <h1>Panel konfiguracyjny firmy</h1>
    <div>
        <button class="btnAdmin" @click="enableConfig">Edytuj ustawienia konfiguracyjne</button>
        <div class="box">
            <div class="headerbox">
                <span>Wybierz firmę</span>
            </div>
            
            <select v-model="selectedCompanies.wartosc_zmiennej" v-on:change="setSelectedCompany" :disabled="disabledS">
                <option v-for="company in companies" :value="company.ID_FIRMY" v-bind:key="company.ID_FIRMY">{{company.NAZWA_PELNA}}</option>
            </select>
        </div>
        <div class="box">
            <div class="headerbox">
                <span>Wybierz kontrahenta dla zleceń</span>
            </div>
            
            <select v-model="selectedClientZlecen.wartosc_zmiennej" v-on:change="setSelectedClientZlecen" :disabled="disabledS">
                <option v-for="client in clients" :value="client.ID_KONTRAHENTA" v-bind:key="client.ID_KONTRAHENTA">{{client.NAZWA_PELNA}}</option>

            </select>
        </div>
        <div class="box">
            <div class="headerbox">
                <span>Wybierz magazyn surowców</span>
            </div>
            
            <select v-model="selectedWarehousesS.wartosc_zmiennej" v-on:change="setSelectedWarehousesS" :disabled="disabledS">
                <option v-for=" warehouse in warehouses" :value="warehouse.ID_MAGAZYNU" v-bind:key="warehouse.ID_MAGAZYNU">{{warehouse.NAZWA}}</option>
            </select>
        </div>
        <div class="box">
            <div class="headerbox">
                <span>Wybierz magazyn wyrobów gotowych</span>
            </div>
            
            <select v-model="selectedWarehousesWG.wartosc_zmiennej" v-on:change="setSelectedWarehousesWG" :disabled="disabledS">
                <option v-for=" warehouse in warehouses" :value="warehouse.ID_MAGAZYNU" v-bind:key="warehouse.ID_MAGAZYNU">{{warehouse.NAZWA}}</option>
            </select>
        </div>
        <button class="btnAdmin" @click="saveConfig" :disabled="disabledS">Zapisz ustawienia konfiguracyjne</button>
    </div>
    <div class="wleft">
            <button class="wlabel" @click="wrocclick"> WRÓĆ </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Storage from "../Storage.vue";
import * as CONFIG from "../config.js";
axios.defaults.withCredentials = false;

export default {
    data: () => ({
        clients: [],
        companies: [],
        warehouses: [],
        configValues: [],
        urlKonfiguracja: "/agent/GALEK.Magazyn/GetKonfiguracja",
        urlMagazyny: "/agent/GALEK.Magazyn/GetMagazyny",
        urlKontrahenci: "/agent/GALEK.Magazyn/GetKontrahenci",
        urlFirmy: "/agent/GALEK.Magazyn/GetFirmy",
        urlUpdate: "/agent/GALEK.Magazyn/AktualizujKonfiguracje",
        selectedClientZlecen: {},
        selectedCompanies: {},
        selectedWarehousesS: {},
        selectedWarehousesWG: {},
        requestBody: {},
        jwt: "",
        disabledS: true,
    }),
    methods:{
        wrocclick(){
            this.$router.push({ path: "/paneladmin" });
        },
	    getData() {
            return axios
                .get(CONFIG.API_URL + this.urlKonfiguracja, {
                headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json",
                        "Authorization": "Bearer " +  this.jwt,
                }
                })
                .then(response => {
                        return response.data;
                })
                .catch(e => {
                        alert("ERROR" + e);
                });
        },
        getMagazyny() {
            return axios
                .get(CONFIG.API_URL + this.urlMagazyny, {
                headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json",
                        "Authorization": "Bearer " +  this.jwt,
                }
                })
                .then(response => {
                        return response.data;
                })
                .catch(e => {
                        alert("ERROR" + e);
                });
        },
        getKontrahenci() {
            return axios
                .get(CONFIG.API_URL + this.urlKontrahenci, {
                headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json",
                        "Authorization": "Bearer " +  this.jwt,
                }
                })
                .then(response => {
                        return response.data;
                })
                .catch(e => {
                        alert("ERROR" + e);
                });
        },
        getFirmy() {
            return axios
                .get(CONFIG.API_URL + this.urlFirmy, {
                headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json",
                        "Authorization": "Bearer " +  this.jwt,
                }
                })
                .then(response => {
                        return response.data;
                })
                .catch(e => {
                        alert("ERROR" + e);
                });
        },
        setSelectedCompany(e){
            this.selectedCompanies.wartosc_zmiennej = e.target.value
        },
        setSelectedClientZlecen(e){
            this.selectedClientZlecen.wartosc_zmiennej = e.target.value
        },
        setSelectedWarehousesS(e){
            this.selectedWarehousesS.wartosc_zmiennej = e.target.value
        },
        setSelectedWarehousesWG(e){
            this.selectedWarehousesWG.wartosc_zmiennej = e.target.value
        },
        saveConfig(){
            this.requestBody = {
                id_firmy: parseInt(this.selectedCompanies.wartosc_zmiennej),
                id_kontrahenta_zlecen: parseInt(this.selectedClientZlecen.wartosc_zmiennej),
                id_magazynu_surowcow: parseInt(this.selectedWarehousesS.wartosc_zmiennej),
                id_magazynu_wyrobow_gotowych: parseInt(this.selectedWarehousesWG.wartosc_zmiennej)
            }
            this.updateConf();
            this.disabledS = true;
        },
        enableConfig(){
            this.disabledS = !this.disabledS ;
        },
        updateConf(){
            return axios
                .put(CONFIG.API_URL + this.urlUpdate, 
                this.requestBody,
                {
                    headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "Accept": "application/json",
                            "Authorization": "Bearer " +  this.jwt,
                    }
                })
                .then(response => {
                        return response.data;
                })
                .catch(e => {
                        alert("ERROR" + e);
                });
        },
    },
    mounted() {
        var that = this;

        Storage.loadJWT("jwt").then(resp => {
            //alert(resp.access_token);
            that.jwt = resp.access_token;
            that.getData().then(data => {
                that.configValues = data;
                that.selectedCompanies = data.find(s => s.nazwa_zmiennej === 'id_firmy')
                that.selectedWarehousesS = data.find(s => s.nazwa_zmiennej === 'id_magazynu_0')
                that.selectedWarehousesWG = data.find(s => s.nazwa_zmiennej === 'id_magazynu_-22')
                that.selectedClientZlecen = data.find(s => s.nazwa_zmiennej === 'id_kontrahenta_zlecen')

            });
            that.getMagazyny().then(data => {
                that.warehouses = data;
		    });
            that.getKontrahenci().then(data => {
                that.clients = data;
		    });
            that.getFirmy().then(data => {
                that.companies = data;
		    });
            
        });
    }
}
</script>
<style>
    .headerbox > span{
        font-size: 1,2em;
        font-weight: bold;
        color: rgb(90, 90, 90);
    }
    select{
        margin: 5px;
        padding: 8px;
        width: 80%;
        border: 1px solid #cdcdcd;
        border-radius: 6px;
    }
    select > option{
        color: rgb(73, 73, 73);
        font-size: 1.1em;
    }
    .box{
        border: 1px solid #cdcdcd;
        margin: 8px;
        padding: 10px;
        box-shadow: 0 0 10px rgba(34, 34, 34, 0.5);
    }
    .wright {
        width: 200px;
        height: 50px;
        position:fixed;
        bottom: 10px;
        right: 10px;
        text-align: right;
        background-color: #FFFFFF;
        /*padding-top: 10px;*/
        float: right;
        margin-top: 40px;
    }
    .wleft {
        width: 200px;
        height: 50px;
        position:fixed;
        bottom: 10px;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        /*margin-left: 400px;*/
    }
    .wlabel {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
    }

</style>



// WEBPACK FOOTER //
// src/components/PanelAdministracyjny/PanelKonfiguracyjny.vue